import React from "react";
import { Box, Grid, Typography, Divider, List, ListItem } from "@mui/material";
import schoolPreview from "../assets/building_preview.jpg"; // Adjust path as needed

function AboutUs() {
  return (
    <Box
      sx={{
        px: 2,
        py: 4,
        maxWidth: "lg",
        mx: "auto",
        fontFamily: "Poppins, sans-serif",
      }}
    >
      <Typography variant="h5" fontWeight={600} mb={2}>
        About Us
      </Typography>

      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Typography variant="body1" sx={{ color: "#444", lineHeight: 1.8 }}>
            The <strong>West African Journal of Life Sciences</strong> is a
            multidisciplinary journal dedicated to scientific research in West
            Africa. The journal's mission is to advance knowledge through the publication of
            high-quality articles that meet global standards and adhere to
            strict publication ethics.
          </Typography>
          <Typography variant="body1" sx={{ color: "#444", lineHeight: 1.8 }}>
            The journal publishes research manuscripts, short communications, technical reports, review articles, and case studies.
          </Typography>
        </Grid>

        <Grid item xs={12} md={6}>
          <Box
            component="img"
            src={schoolPreview}
            alt="School Preview"
            sx={{
              width: "100%",
              height: "auto",
              borderRadius: 2,
              boxShadow: 2,
            }}
          />
        </Grid>
      </Grid>

      <Divider sx={{ my: 4 }} />

      <Typography variant="h6" fontWeight={600} gutterBottom>
        Journal Information
      </Typography>

      <Typography variant="body2" sx={{ color: "#333", mb: 2, lineHeight: 1.7 }}>
        <strong>Journal Title:</strong> West African Journal of Life Sciences<br />
        <strong>Journal Short Title:</strong> WAJLS<br />
        <strong>Journal ISSN (Print):</strong> 2992-5150<br />
        <strong>Country of Publication:</strong> Nigeria<br />
        <strong>Publication Coverage:</strong> International<br />
        <strong>Frequency:</strong> Biannual<br />
        <strong>Issue Month:</strong> June and December<br />
        <strong>Review Type:</strong> Double-blinded peer-review<br />
        <strong>Review Duration:</strong> 1-2 months per article<br />
        <strong>Review Rounds:</strong> 2-3 per article<br />
        <strong>Open Access:</strong> Yes<br />
        <strong>Licence:</strong> Creative Commons Attribution License 4.0<br />
        <strong>Language:</strong> English
      </Typography>

      {/* <Divider sx={{ my: 4 }} />

      <Typography variant="h6" fontWeight={600} gutterBottom>
        Scope
      </Typography>

      <List sx={{ listStyleType: 'disc', pl: 4, color: "#444" }}>
        {[
          "Agricultural Science",
          "Food Science",
          "Biochemistry",
          "Plant Science and Botany",
          "Microbiology",
          "Zoology",
          "Nutrition",
          "Dietetics"
        ].map((field) => (
          <ListItem key={field} sx={{ display: 'list-item', py: 0 }}>
            {field}
          </ListItem>
        ))}
      </List> */}
    </Box>
  );
}

export default AboutUs;
